import type { DateRange } from 'react-day-picker'

import { SpendingCustomerListDialog } from '@/modules/tracking/new-subscriber-analysis/ui/dialog/spending-customer-list.tsx'
import { PaginationProvider } from '@/utils/pagination/pagination-context.tsx'

const SpendingHighCustomerListDialogTexts = {
  title: 'High-Spending Customer List',
  description:
    'In this List you can see all the new High-Spending Customers within your set timeframe and minimum spend. You can create a list or view the High-Spending Customers individually.',
}

interface Props {
  isOpen: boolean
  onClose: () => void
  creatorId: number
  limit: number
  date: DateRange
}

export const HighSpendingCustomerList = ({
  isOpen,
  onClose,
  creatorId,
  limit,
  date,
}: Props) => {
  return (
    <PaginationProvider>
      <SpendingCustomerListDialog
        title={SpendingHighCustomerListDialogTexts.title}
        description={SpendingHighCustomerListDialogTexts.description}
        isOpen={isOpen}
        onClose={onClose}
        creatorId={creatorId!}
        spendLimit={limit}
        high={true}
        date={date}
      />
    </PaginationProvider>
  )
}
